<style scoped>

.query-form {
    margin-top: 40px;
}
.row-ruleForm {
    display: flex;
    flex-direction: row;
}
</style>

<template>
    <div>
        <h1>发放邮件奖励</h1>
        <div class="query-form">
            <el-form :model="ruleUserId" status-icon :rules="addUserIdRules" ref="ruleUserId" class="demo-ruleForm row-ruleForm">
                <el-form-item label="用户id" label-width="80px" prop="userId">
                    <el-input type="number" v-model="ruleUserId.userId" auto-complete="off" placeholder="请输入用户id" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label-width="80px">
                    <el-button class="button-width" type="primary" size="small" @click="addUserId('ruleUserId')">添加用户</el-button>
                </el-form-item>
            </el-form>

            <el-form :model="ruleProps" status-icon :rules="addPropsRules" ref="ruleProps" class="demo-ruleForm row-ruleForm">
                <el-form-item label="物品id" label-width="80px" prop="propsId">
                    <el-input type="number" v-model="ruleProps.propsId" auto-complete="off" placeholder="请输入物品id" style="width:150px;"></el-input>
                </el-form-item>
                <el-form-item label="数量" label-width="80px" prop="itemNum">
                    <el-input type="number" v-model="ruleProps.itemNum" auto-complete="off" placeholder="请输入物品数量" style="width:150px;"></el-input>
                </el-form-item>
                <el-form-item label-width="80px">
                    <el-button class="button-width" type="primary" size="small" @click="addPropsItem('ruleProps')">添加物品</el-button>
                </el-form-item>
            </el-form>

            <h1>已选信息</h1>
            <el-form class="demo-ruleForm">
                <el-form-item label="邮件标题" label-width="80px" prop="title">
                    <el-input type="text" v-model="addPresentMail.title" auto-complete="off" placeholder="请输入邮件标题" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="邮件内容" label-width="80px" prop="content">
                    <el-input type="text" v-model="addPresentMail.content" auto-complete="off" placeholder="请输入邮件内容" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="用户id" label-width="80px" >
                    <el-input v-model="addPresentMail.userIds" :disabled="true" style="width:300px;"></el-input>    
                </el-form-item>
                <div v-if="addPresentMail.propsItemList.length != 0">
                    <div v-for="(item,index) in addPresentMail.propsItemList" :key="index" class="row-ruleForm">
                        <el-form-item label="物品id" label-width="80px" >
                            <el-input v-model="item.propsId" :disabled="true" style="width:150px;"></el-input>    
                        </el-form-item>
                        <el-form-item label="数量" label-width="80px" >
                            <el-input  v-model="item.itemNum" :disabled="true" style="width:150px;"></el-input>    
                        </el-form-item>
                        <el-form-item label-width="80px">
                            <el-button class="button-width" type="danger" @click="removePropsItem(index)">删除</el-button>
                        </el-form-item>
                    </div>
                </div>
                <div v-if="addPresentMail.propsItemList.length == 0">
                    <div class="row-ruleForm">
                        <el-form-item label="物品id" label-width="80px" >
                            <el-input :disabled="true" style="width:150px;"></el-input>    
                        </el-form-item>
                        <el-form-item label="数量" label-width="80px" >
                            <el-input  :disabled="true" style="width:150px;"></el-input>    
                        </el-form-item>
                    </div>
                </div>
                
                
                <el-form-item label-width="80px">
                    <el-button class="button-width" type="danger" @click="reset()">重置</el-button>
                    <el-button class="button-width" type="primary" @click="submitPresentMail()">发放奖励</el-button>
                </el-form-item>
            </el-form>
                
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import {addPresentMail} from '@/request/api';
export default {
    data() {
        var checkUserId = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户id不能为空'));
            }
            callback();
        };
        var checkPropsId = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('物品id不能为空'));
            }
            callback();
        };
        var checkItemNum= (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户数量不能为空'));
            }
            callback();
        };
        return {
            dialogFormVisible: false,
            addPresentMail: {
                title: '',
                content: '',
                userIds: '',
                userIdList: [],
                propsItemList: []
            },
            ruleUserId: {
                userId: '',
            },
            addUserIdRules: {
                userId: [
                    { validator: checkUserId, trigger: 'blur'}
                ]
            },
            ruleProps: {
                propsId: '',
                itemNum: '',
            },
            addPropsRules: {
                propsId: [
                    { validator: checkPropsId, trigger: 'blur'}
                ],
                itemNum: [
                    { validator: checkItemNum, trigger: 'blur'}
                ]
            }
        };
    },
    methods: {
        addUserId(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var userIdList = this.addPresentMail.userIdList;
                    userIdList.push(this.ruleUserId.userId);

                    for (let i=0, len=userIdList.length; i<len; i++) {
                        for (let j=i+1; j<len; j++) {
                            if (userIdList[i] == userIdList[j]) {
                                userIdList.splice(j, 1);
                                //  防止数组塌陷
                                len--;
                                j--;    
                            }
                        }
                    }

                    this.addPresentMail.userIds = '';
                    userIdList.forEach((item,index) => {
                        this.addPresentMail.userIds = this.addPresentMail.userIds + item + ","
                    });
                    this.$refs['ruleUserId'].resetFields();
                } else {
                    console.log('error');
                    return false;
                }
            })
        },
        addPropsItem(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var propsItemList = this.addPresentMail.propsItemList;
                    var propsItem = {
                        propsId: this.ruleProps.propsId,
                        itemNum: this.ruleProps.itemNum,
                    }
                    propsItemList.push(propsItem);
                    this.$refs['ruleProps'].resetFields();
                } else {
                    console.log('error');
                    return false;
                }
            })
        },
        removePropsItem(index) {
            this.addPresentMail.propsItemList.splice(index, 1);
        },
        reset() {
            this.addPresentMail = {
                title: '',
                content: '',
                userIds: '',
                userIdList: [],
                propsItemList: []
            }
        },
        submitPresentMail(formName) {
            console.log(this.addPresentMail)
            if (this.addPresentMail.title == '') {
                this.$message.error('请输入邮件标题');
                return;
            }
            if (this.addPresentMail.content == '') {
                this.$message.error('请输入邮件内容');
                return;
            }
            if (this.addPresentMail.userIdList == 0) {
                this.$message.error('请选择用户');
                return;
            }
            if (this.addPresentMail.propsItemList == 0) {
                this.$message.error('请选择物品');
                return;
            }
            addPresentMail(
                this.addPresentMail
            ).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("发放成功");
                    this.reset();
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/mail/presentMail.vue